import HeroSlider from "../components/home/HeroSlider";
import AboutSection from "../components/home/AboutSection";
import MarqueeBand from "../components/home/MarqueeBand";
import PartnersSection from "../components/home/PartnersSection";
import BranchesSection from "../components/home/BranchesSection";
import ContactBand from "../components/home/ContactBand";
export default function Home() {
    return (
        <>
            <HeroSlider />
            <AboutSection />
            <MarqueeBand />
            <PartnersSection />
            <BranchesSection />
            <ContactBand />
        </>
    );
}
